
<!-- 
 * @description: 小图标
 * @fileName: svg.vue 
 * @author:ninghf 
 * @date: 2021-10-12 19:57:47
!-->
<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName () {
      return `#icon-${this.iconClass}`
    },
    svgClass () {
      if (this.className) {
        return 'icon ' + this.className
      } else {
        return 'icon'
      }
    }
  },
}
</script>

<style scoped>
.icon {
      width: 1em;
      height: 1em;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
  }
</style>
